<template>
  <div v-show="modelValue">
    <div class="modal-root" >
      <div class="modal-title p-2">
        <div class="row p-2">
          <div class="col-6">
            {{title}}

          </div>
          <div class="col-6 px-4" style="text-align: left;">
            <button @click="model=false" style="color:white">
              <img src="/img/plus.svg" style="  rotate: 48deg !important;" alt="">
            </button>
          </div>
        </div>

      </div>

      <slot></slot>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>

export default {
  name: 'CModal',

  inheritAttrs: false,
  components: {},
  props: {
    modelValue: {type:Boolean,default:false},
    title: String,

  },
  data() {
    return {
      model: '',

    }
  },
  watch: {
    'model': function () {
      console.log("model changed", this.model)
      this.$emit('update:modelValue', this.model);
    },
    'modelValue': function () {
      this.model = this.modelValue
      this.$emit('update:modelValue', this.model);
    }
  },
  computed: {},
  mounted() {

  },
  methods: {},


}
</script>
<style>
.modal-root{
  background: #28364e;
  color: black;
  width: 80%;
  position: fixed;
  top: 10%;
  max-height: 80%;
  min-height: 40%;
  height:fit-content;
  border-radius: 10px;
  right: 10%;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1000;
}
.modal-title{
  color: white;
  font-size: 22px !important;
}
.modal-overlay{
  position: absolute;
  width: 100%;
  height: 100%;
  background: #000000b5;
  z-index: 999;
  right: 0;
  top: 0;
}
</style>